// extracted by mini-css-extract-plugin
export default {"item":"user-create_item__it5Gk"};